import DecorateLine from './src/decorate-line.vue'

export default DecorateLine
